var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.styles.days_of_week},_vm._l((_vm.days_of_week),function(day,index){return _c('div',{key:index,staticClass:"color-gray-800",class:_vm.styles.date},[_vm._v(_vm._s(day))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }